import {type QuotaKeys, type QuotaLimit} from '@pinecone-experience/commons/quotas';
import {type Dispatch, createAction} from '@reduxjs/toolkit';
import DashboardApi from '../api/DashboardApi';
import {NotificationTypes, enqueNotification} from './notificationActions';
import {decodeErrorMessage} from './utils/errors';

export const getProjectQuotaLimitsRequest = createAction<{projectId: string}>(
  'PROJECT_QUOTA_LIMITS_REQUEST',
);
export const getProjectQuotaLimitsSuccess = createAction<{
  projectId: string;
  quotaLimits: Record<QuotaKeys, QuotaLimit>;
}>('PROJECT_QUOTA_LIMITS_SUCCESS');
export const getProjectQuotaLimitsFailure = createAction<{projectId: string; error: Error}>(
  'PROJECT_QUOTA_LIMITS_FAILURE',
);

export const getOrganizationQuotaUtilizationRequest = createAction<{organizationId: string}>(
  'ORGANIZATION_QUOTA_UTILIZATION_REQUEST',
);
export const getOrganizationQuotaUtilizationSuccess = createAction<{
  organizationId: string;
  quotaUtilization: Record<QuotaKeys, number>;
}>('ORGANIZATION_QUOTA_UTILIZATION_SUCCESS');
export const getOrganizationQuotaUtilizationFailure = createAction<{
  organizationId: string;
  error: Error;
}>('ORGANIZATION_QUOTA_UTILIZATION_FAILURE');

export function getProjectQuotaLimits(token: string, data: {projectId: string}) {
  return async (dispatch: Dispatch) => {
    dispatch(getProjectQuotaLimitsRequest({projectId: data.projectId}));
    return new DashboardApi(token)
      .getProjectQuotaLimits(data.projectId)
      .then((res) => {
        dispatch(
          getProjectQuotaLimitsSuccess({projectId: data.projectId, quotaLimits: res.quotaLimits}),
        );
      })
      .catch((error) => {
        dispatch(
          enqueNotification({
            type: NotificationTypes.ERROR,
            text: `Something went wrong fetching quota limits for ${
              data.projectId
            }: ${decodeErrorMessage(error.message)}`,
          }),
        );
        dispatch(getProjectQuotaLimitsFailure({projectId: data.projectId, error}));
      });
  };
}

export function getOrganizationQuotaUtilization(token: string, data: {organizationId: string}) {
  return async (dispatch: Dispatch) => {
    dispatch(getOrganizationQuotaUtilizationRequest({organizationId: data.organizationId}));
    return new DashboardApi(token)
      .getOrganizationQuotaUtilization(data.organizationId)
      .then((res) => {
        dispatch(
          getOrganizationQuotaUtilizationSuccess({
            organizationId: data.organizationId,
            quotaUtilization: res.quotaUtilization,
          }),
        );
      })
      .catch((error) => {
        dispatch(
          getOrganizationQuotaUtilizationFailure({
            organizationId: data.organizationId,
            error: decodeErrorMessage(error.message),
          }),
        );
      });
  };
}
